<section class="create">
    <div class="create_title">Add New Entity Profile</div>
    <div cdkFocusInitial class="close-dialog" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </div>
    <mat-dialog-content>
        <div class="create_content">
            <form (ngSubmit)="onCabsMainlInfoSubmit()" [formGroup]="editCabsMainInfo">
                <div class="row">


                    <div class="col-12">
                        <app-image-control [ratio]="1 / 1" [maxSize]="5" [src]="logoSrc?logoSrc:null"
                            (imageReady)="logo = $event.blob; logoSrc = $event.src"
                            (errors)="fileTypeError = $event.type; fileSizeError = $event.size">
                        </app-image-control>
                        <p *ngIf="fileTypeError" class="has-error mt-2 d-block">
                            {{'userProfile.Invalid Type' | translate}}
                        </p>
                        <p class="has-error mt-2 d-block" *ngIf="fileSizeError">{{ 'forms.Max-files' | translate }}
                            {{5}} Mb</p>

                        <p class="has-error mt-2 d-block" *ngIf="isSubmitted && (!logo && !logoSrc)">
                            Entity logo is Required
                        </p>

                    </div>

                    <div class="col-sm-12">
                        <h4 class="fields-title">Name</h4>
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Organization name as per License</mat-label>
                                    <input class="profile-inputs_c-grey-6" required formControlName="cabNameEnglish"
                                        matInput maxlength="500" />
                                    <mat-error *ngIf="hasError('cabNameEnglish', 'required')">
                                        Field is Required
                                    </mat-error>
                                    <mat-error *ngIf="hasError('cabNameEnglish', 'pattern')">
                                        Field in English accept only English Letters,Numbers and
                                        Spaces
                                    </mat-error>
                                    <mat-error *ngIf="
                      editCabsMainInfo.get('cabNameEnglish').errors?.serverError
                    ">
                                        {{
                                        editCabsMainInfo.get('cabNameEnglish').errors?.serverError
                                        }}
                                    </mat-error>
                                    <mat-error *ngIf="
                      editCabsMainInfo.get('cabNameEnglish').errors
                        ?.whiteSpaceValidator
                    ">
                                        Field is Required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Entity Name (Arabic) Removed as per eng/Eslam -->
                            <!-- <div class="col-sm-12">
                <mat-form-field appearance="outline" class="form-group">
                  <mat-label>Entity Name [In Arabic]</mat-label>
                  <input class="profile-inputs_c-grey-6" formControlName="cabNameArabic" matInput maxlength="200" />
                  <mat-error *ngIf="hasError('cabNameArabic', 'required')">
                    is Required
                  </mat-error>
                  <mat-error *ngIf="hasError('cabNameArabic', 'pattern')">
                    Field in Arabic accept only Arabic Letters,Numbers and
                    Spaces
                  </mat-error>
                  <mat-error *ngIf="
                      editCabsMainInfo.get('cabNameArabic').errors?.serverError
                    ">
                    {{
                    editCabsMainInfo.get('cabNameArabic').errors?.serverError
                    }}
                  </mat-error>
                </mat-form-field>
              </div> -->
                        </div>
                    </div>
                    <div class="col-sm-12 mb-4">
                        <h4 class="fields-title">Address</h4>
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Registered Physical Location Address</mat-label>
                                    <input class="profile-inputs_c-grey-6" required formControlName="address" matInput
                                        maxlength="200" />
                                    <mat-error *ngIf="hasError('address', 'required')">
                                        Is Required
                                    </mat-error>
                                    <mat-error *ngIf="hasError('address', 'pattern')">
                                        accept only english characters and (. , / ( ) # & - +)
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Country</mat-label>
                                    <mat-select [compareWith]="regionCompare" required class="profile-inputs_c-grey-6"
                                        formControlName="country">
                                        <mat-option *ngFor="let item of countryCodes" [value]="item.country_token">{{
                                            item.countryName }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="hasError('country', 'required')">
                                        Is Required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>City</mat-label>
                                    <input class="profile-inputs_c-grey-6" required formControlName="city" matInput
                                        maxlength="20" />
                                    <mat-error *ngIf="hasError('city', 'required')">
                                        Is Required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Region (Area)</mat-label>
                                    <input class="profile-inputs_c-grey-6" required formControlName="region" matInput
                                        maxlength="20" />
                                    <mat-error *ngIf="hasError('region', 'required')">
                                        Is Required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>PO Box No./ZIP Code</mat-label>
                                    <input class="profile-inputs_c-grey-6" formControlName="zipCode" matInput
                                        maxlength="10" />
                                    <mat-error *ngIf="hasError('zipCode', 'required')">
                                        Is Required
                                    </mat-error>
                                    <mat-error *ngIf="hasError('zipCode', 'minlength')">
                                        The entered value below the minimum length of 2
                                    </mat-error>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                    <div class="col-sm-12">
                        <h4 class="fields-title">Contacts</h4>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group mb-4 profile-inputs_c-grey-6">
                                    <ngx-intl-tel-input [customPlaceholder]="'Tel. No.*'"
                                        [enableAutoCountrySelect]="true" [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true" [enablePlaceholder]="true" [maxLength]="40"
                                        [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true"
                                        [required]="true" [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                    ]" [searchCountryFlag]="true" [searchCountryFlag]="true" [selectFirstCountry]="false"
                                        [selectedCountryISO]="CountryISO.UnitedArabEmirates"
                                        [separateDialCode]="separateDialCode" formControlName="phone" name="phone">
                                    </ngx-intl-tel-input>
                                    <mat-error *ngIf="
                      editCabsMainInfo.controls['phone'].invalid &&
                        isSubmitted
                        ">
                                        <div *ngIf="editCabsMainInfo.controls['phone'].errors.required"
                                            class="intl-validation">
                                            Is Required
                                        </div>
                                        <div *ngIf="editCabsMainInfo.controls['phone'].errors.validatePhoneNumber"
                                            class="intl-validation">
                                            Enter valid number according selected country (10 ~ 40)
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group mb-4 profile-inputs_c-grey-6">
                                    <ngx-intl-tel-input [customPlaceholder]="'Fax No.'" [enableAutoCountrySelect]="true"
                                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                        [enablePlaceholder]="true" [maxLength]="40"
                                        [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true"
                                        [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                    ]" [searchCountryFlag]="true" [searchCountryFlag]="true" [selectFirstCountry]="false"
                                        [selectedCountryISO]="CountryISO.UnitedArabEmirates"
                                        [separateDialCode]="separateDialCode" formControlName="fax" name="faxc">
                                    </ngx-intl-tel-input>
                                    <mat-error *ngIf="
                      editCabsMainInfo.controls['fax'].invalid &&
                      isSubmitted
                    ">
                                        <div *ngIf="editCabsMainInfo.controls['fax'].errors.required"
                                            class="intl-validation">
                                            Is Required
                                        </div>
                                        <div *ngIf="editCabsMainInfo.controls['fax'].errors.validatePhoneNumber"
                                            class="intl-validation">
                                            Enter valid number according selected country (10 ~ 40)
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Official email address</mat-label>
                                    <input [disabled]="data.isEmailDisabled" required class="profile-inputs_c-grey-6"
                                        formControlName="email" matInput maxlength="50" placeholder="pat@example.com" />
                                    <mat-error *ngIf="hasError('email', 'required')">
                                        Is Required
                                    </mat-error>
                                    <mat-error *ngIf="hasError('email', 'emailError')">
                                          {{ editCabsMainInfo.controls['email'].errors['emailError'] }}
                                    </mat-error>
                                    <mat-error *ngIf="hasError('email', 'pattern')">Validate the Email format only
                                    </mat-error>
                                    <mat-error *ngIf="hasError('email', 'emailTaken')">
                                        This email is already registered at the system
                                    </mat-error>
                                    <mat-error *ngIf="editCabsMainInfo.get('email').errors?.serverError">
                                        {{ editCabsMainInfo.get('email').errors?.serverError }}
                                    </mat-error>
                                </mat-form-field>
                            </div>


                            <div class="col-sm-12">
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>Website</mat-label>
                                    <input class="profile-inputs_c-grey-6" required formControlName="website" matInput
                                        maxlength="50" />
                                    <mat-error *ngIf="hasError('website', 'required')">
                                        Is Required
                                    </mat-error>
                                    <mat-error *ngIf="hasError('website', 'pattern')">
                                        Validate website is Valid URL
                                    </mat-error>
                                </mat-form-field>
                            </div>


                        </div>
                    </div>


                    <div class="col-sm-12 profile-actions">
                        <div class="row">
                            <div class="col-md-12">
                                <button [class.loading]="loading" [disabled]="loading" class="mat_orange w-100"
                                    mat-raised-button>
                                    <span>Add</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</section>